import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import checkAuth from "./system/auth/authenticate.js";
Vue.use(Router);

// create new router


const routes = [
  {
    path: "/web/",
    component: () => import("./views"),
    redirect: "/web/homepage",
    children: [
      { 
        path: "failed",
        beforeEnter: checkAuth,
        component: () => import("./views/profile/topup/failed.vue"),
      },
      {
        path: "success",
        beforeEnter: checkAuth,
        component: () => import("./views/profile/topup/success.vue"),
      },
      {
        path: "homepage",
        beforeEnter: checkAuth,
        component: () => import("./views/homepage/homepage"),
      },
      {
        path: "membership",
        beforeEnter: checkAuth,
        component: () => import("./views/membership/membership"),
      },
      {
        path: "ib_tree",
        beforeEnter: checkAuth,
        component: () => import("./views/member/ib_tree"),
      },
      {
        path: "profile",
        beforeEnter: checkAuth,
        component: () => import("./views/profile"),
        redirect: "/web/profile/main",
        children: [
          {
            path: "main",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/main.vue"),
          },
          {
            path: "account_info",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/account_info.vue"),
          },
          {
            path: "security_info",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/security/security.vue"),
          },
          {
            path: "kyc",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/kyc.vue"),
          },
          {
            path: "topup",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/topup/topup.vue"),
          },
          {
            path: "bank_details",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/bank_details.vue"),
          },
          {
            path: "transaction",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/transaction/transaction.vue"),
          },
          {
            path: "earned_rewards",
            beforeEnter: checkAuth,
            component: () => import("./views/profile/bonus/earned_reward.vue"),
          },
        ]
      },


    ]
  },
  {
    path: "/web/sessions",
    component: () => import("./views/sessions"),
    children: [
      {
        path: "login",
        component: () => import("./views/sessions/login"),
      },
    ]
  },
  {
    path: "/register",
    component: () => import("./views/sessions/register"),
  },
  {
    path: "/web/set-sec-password",
    meta: { requiresAuth: true },
    component: () => import("./views/sessions/set-sec-password"),
  },
  {
    path: "/web/successful",
    component: () => import("./views/profile/topup/success")
  },

  {
    path: "/web/failed",
    component: () => import("./views/profile/topup/failed")
  },
  {
    path: "*",
    component: () => import("./views/pages/notFound")
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "open",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
// var liveChat = document.getElementById('chat-widget-container');
router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.


  if (from.path.includes('manage')) {
    next();

  } else {
    if (to.path) {
      // Start the route progress bar.

      NProgress.start();
      NProgress.set(0.1);
    }
    next();

  }
});

router.afterEach(() => {
  // Remove initial loading
  const gullPreLoading = document.getElementById("loading_wrap");
  if (gullPreLoading) {
    gullPreLoading.style.display = "none";
  }
  setTimeout(() => NProgress.done(), 100);
});

export default router;
